import { render, staticRenderFns } from "./ClientNotificationForm.vue?vue&type=template&id=11705b77&scoped=true&"
import script from "./ClientNotificationForm.vue?vue&type=script&lang=js&"
export * from "./ClientNotificationForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientNotificationForm.vue?vue&type=style&index=0&id=11705b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11705b77",
  null
  
)

export default component.exports